<template>
  <div class="d-flex" style="align-items: center;">
    <div v-if="item.has_banking_transaction" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Connected to a bank transaction')">
      <font-awesome-icon icon="fa-solid fa-building-columns" />
    </div>
    <div v-if="item.created_via === 'woocommerce'" class="status-circle-badge badge-image" v-b-tooltip.hover :title="$gettext('Created via Woocommerce')">
        <img src="/static/img/woocommerce2.png" />
    </div>
    <div v-if="item.credited_invoice" class="status-circle-badge badge-brown" v-b-tooltip.hover :title="$gettext('Credited')">
      <font-awesome-icon icon="fa-solid fa-rotate-left" />
    </div>
    <div v-if="item.currency !== 'EUR'" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Foreign currency')">
      <font-awesome-icon icon="fa-solid fa-dollar-sign" />
    </div>
    <div v-if="item.display_status.error" class="status-circle-badge badge-danger" v-b-tooltip.hover :title="$gettext('Error sending the invoice')">
      <font-awesome-icon icon="fa-solid fa-triangle-exclamation" />
    </div>
    <div v-if="!item.display_status.error && item.display_status.detailed_status === 'sending'" class="status-circle-badge badge-spinner" v-b-tooltip.hover :title="$gettext('Sending')">
    </div>
    <div v-if="item.uploaded || item.correction" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Uploaded')">
      <font-awesome-icon icon="fa-solid fa-cloud-arrow-up" />
    </div>
    <div v-if="(item.status === 's' || item.status === 'p') && item.verifactuinvoice && 
              (item.verifactuinvoice.status == 'correct' || item.verifactuinvoice.status == 'partially_correct' || 
              item.verifactuinvoice.status == 'cancellation_incorrect' || item.verifactuinvoice.status == 'error_cancelling')" 
        v-b-tooltip.hover :title="$gettext('Invoice sent to AEAT')">
        
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" style="height: 22px; width: 22px;">
          <path d="M0 0h150v150H0V0z" fill="none"/><path fill="#00549a" d="M141.9 130.2L76.1 17.8H22.8l66.7 112.4z"/>
          <path d="M23.3 121.4l6.5 10.1c57.8-3.3 104.2-50.6 108.6-83.7l-7.3-9.1c-9.4 45.1-67.5 80-107.8 82.7z" fill="#ecba0b"/>
          <path d="M38.9 59.1L44.3 70c-6.4 5.9-9.5 9.9-14 17.3-6 10-8.4 16.5-10.3 28l-8-13c2.6-8.3 4.7-12.9 9-20.5 5.7-9.6 9.8-14.8 17.9-22.7z" fill="#d12920"/>
        </svg>
    </div>
    <div v-if="(item.status === 's' || item.status === 'p') && item.verifactuinvoice && 
              (item.verifactuinvoice.status == 'cancelled' || item.verifactuinvoice.status == 'cancelled_with_errors')" 
        v-b-tooltip.hover :title="$gettext('Invoice canceled in the AEAT')">
        
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" style="height: 22px; width: 22px;">
          <path d="M0 0h150v150H0V0z" fill="none"/><path fill="#c94c4c" d="M141.9 130.2L76.1 17.8H22.8l66.7 112.4z"/>
          <path d="M23.3 121.4l6.5 10.1c57.8-3.3 104.2-50.6 108.6-83.7l-7.3-9.1c-9.4 45.1-67.5 80-107.8 82.7z" fill="#eea29a"/>
          <path d="M38.9 59.1L44.3 70c-6.4 5.9-9.5 9.9-14 17.3-6 10-8.4 16.5-10.3 28l-8-13c2.6-8.3 4.7-12.9 9-20.5 5.7-9.6 9.8-14.8 17.9-22.7z" fill="#f7786b"/>
        </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusIcons',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {

  },
}
</script>

<style lang="scss" scoped>

</style>